import { uriTransformer } from 'react-markdown'

const REVOLUT_DEEPLINK_REGEXP = /^(revolut|revolut-business|revolut-junior):\/\//

export function urlTransform(href: string): string {
  const match = href.match(REVOLUT_DEEPLINK_REGEXP)

  if (match) {
    const proto = match[1]
    const safeUrl = uriTransformer(href.replace(proto, 'http'))

    return safeUrl.replace('http', proto)
  }

  return uriTransformer(href)
}
